export function snakeToPascal(input: string) {
  return input.toLowerCase().replace(/(^\w|_\w)/g, (match) => match.replace('_', '').toUpperCase());
}
